import React from "react";
import { GridContainer, GridItem } from "./MonthlyReport.styles";
import MonthlyReportSummary from "./MonthlyReport.summary";
import MonthlyReportFeesBreakdown from "./MonthlyReport.feesBreakdown";
import MonthlyReportCommissionConfig from "./MonthlyReport.commissionConfig";
import MonthlyReportISOAccordion from "./MonthlyReport.isoAccordion";
import MonthlyReportMerchantsTable from "./MonthlyReport.merchantsTable";

const MonthlyReportAcquirer = ({ reportData }) => {
  const { summary, commission_config, isos, direct_merchants } = reportData;

  return (
    <GridContainer spacing={0}>
      <MonthlyReportSummary summary={summary} />
      <MonthlyReportFeesBreakdown summary={summary} />
      <MonthlyReportCommissionConfig commission_config={commission_config} userType="acquirer" />
      {direct_merchants && direct_merchants.length > 0 && (
        <GridItem xs={12} padding="0 0 15px 0">
          <MonthlyReportMerchantsTable merchants={direct_merchants} title="Direct Merchants" />
        </GridItem>
      )}
      <MonthlyReportISOAccordion isos={isos} />
    </GridContainer>
  );
};

export default MonthlyReportAcquirer;

